import type { PrismAnimationType } from './prismTypes';

export const PRISM_DEFAULT_MAX_DPR = 2;
export const PRISM_MIN_DPR = 1;
// rAF-based FPS aggregation window feeding the health gate. renderMs only measures GL
// command submission (~0 even when GPU-bound), so true frame health lives in the rAF
// spacing - aggregated per window and reported as fps + frame-delta. Works cross-browser,
// unlike the Chromium-only longtask/LCP PerformanceObservers.
export const PRISM_FPS_WINDOW_MS = 1000;

export const PRISM_ANIMATION_ROTATE: PrismAnimationType = 'rotate';
export const PRISM_ANIMATION_HOVER: PrismAnimationType = 'hover';
export const PRISM_ANIMATION_3DROTATE: PrismAnimationType = '3drotate';
export const PRISM_MOTION_VALUE_CHANGE_EVENT = 'change';

export const PRISM_ROTATION_HOVER_MAX_ANGLE = 0.6;
export const PRISM_ROTATION_ROLL_RETURN_INERTIA = 0.1;
export const PRISM_ROTATION_SETTLE_EPSILON = 1e-4;
export const PRISM_TIME_STOP_EPSILON = 1e-6;
export const PRISM_NOISE_ZERO_EPSILON = 1e-6;
export const PRISM_POINTER_MAX = 1;
export const PRISM_CANVAS_MIN_SIZE = 1;
export const PRISM_BASE_WOBBLE_ENABLED = 1;
export const PRISM_BASE_WOBBLE_DISABLED = 0;
